<ds-results-back-button *ngIf="showBackButton$ | async" [back]="back"></ds-results-back-button>
<div class="row" *ngIf="iiifEnabled">
  <div class="col-12">
    <ds-mirador-viewer  id="iiif-viewer"
                        [object]="object"
                        [searchable]="iiifSearchEnabled"
                        [query]="iiifQuery$ | async">
    </ds-mirador-viewer>
  </div>
</div>
<div class="d-flex flex-row">
  <ds-item-page-title-field [item]="object" class="mr-auto">
  </ds-item-page-title-field>
  <ds-dso-edit-menu></ds-dso-edit-menu>
</div>
<div class="row columnset-row">
  <div class="col-xs-12 col-md-4 left-column">
    <ng-container *ngIf="!(mediaViewer.image || mediaViewer.video)">
      <ds-metadata-field-wrapper [hideIfNoTextContent]="false">
        <ds-thumbnail [thumbnail]="object?.thumbnail | async"></ds-thumbnail>
      </ds-metadata-field-wrapper>
    </ng-container>
    <div *ngIf="mediaViewer.image || mediaViewer.video" class="mb-2">
      <ds-media-viewer [item]="object"></ds-media-viewer>
    </div>
    <ds-item-page-collections [item]="object"></ds-item-page-collections>
    <ds-generic-item-page-field [item]="object"
                                [fields]="['dc.date.issued']"
                                [label]="'item.page.publicationRange'">
    </ds-generic-item-page-field>
    <ds-item-page-uri-field [item]="object"
                            [fields]="['dc.identifier.urn']"
                            [label]="'item.page.urn'">
    </ds-item-page-uri-field>
    <ds-generic-item-page-field [item]="object"
                                [fields]="['dc.identifier.doi']"
                                [label]="'item.page.doi'">
    </ds-generic-item-page-field>
    <ds-bfs-license-field [item]="object"></ds-bfs-license-field>
    <div class="item-page-field">
      <div class="simple-view-element">
        <h2 class="simple-view-element-header ng-star-inserted">{{ 'item.link.feedback' | translate }}</h2>
        <div class="simple-view-element-body">
          <a class="" routerLink="/info/feedback">{{ 'item.link.feedback.form' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xs-12 col-md-7 center-column">
    <ds-related-items
      [parentItem]="object"
      [relationType]="'isPublicationOfSeries'"
      [label]="'relationships.isPublicationsOf' | translate">
    </ds-related-items>
    <ds-related-items
      [parentItem]="object"
      [relationType]="'isReportOfSeries'"
      [label]="'relationships.isReportOf' | translate">
    </ds-related-items>
    <ds-item-page-abstract-field [item]="object"></ds-item-page-abstract-field>
    <ds-metadata-representation-list class="ds-item-page-mixed-author-field"
                                     [parentItem]="object"
                                     [itemType]="'Person'"
                                     [metadataFields]="['dc.creator']"
                                     [label]="'item.page.authors' | translate">
    </ds-metadata-representation-list>
    <ds-metadata-representation-list class="ds-item-page-mixed-author-field"
                                     [parentItem]="object"
                                     [itemType]="'Person'"
                                     [metadataFields]="['dc.contributor.author']"
                                     [label]="'item.page.contributors' | translate">
    </ds-metadata-representation-list>
    <ds-localized-generic-item-page-field [item]="object"
                                          [fields]="['dc.publisher']"
                                          [enableMarkdown]="false"
                                          [label]="'item.page.publisher'">
    </ds-localized-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
                                [fields]="['dc.contributor']"
                                [label]="'item.page.contributingOrganizations'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
                                [fields]="['dc.contributor.sponsor']"
                                [label]="'item.page.fundingOrganizations'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
                                [fields]="['dc.relation.grantno']"
                                [label]="'item.page.supportCode'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
                                [fields]="['dc.identifier.reportnumber']"
                                [label]="'item.page.reportnumber'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
                                [fields]="['dc.identifier.isbn']"
                                [label]="'item.page.isbn'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
                                [fields]="['dc.identifier.issn']"
                                [label]="'item.page.issn'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
                                [fields]="['dc.identifier.citation']"
                                [label]="'item.page.citation'">
    </ds-generic-item-page-field>
    <ds-language-item-page-field [item]="object"
                                [fields]="['dc.language.iso']"
                                [label]="'item.page.language'">
    </ds-language-item-page-field>

    <div class="citation-container">
      <h2 class="simple-view-element-header">{{ 'item.page.citationSuggestion.header' | translate }}</h2>
      <div class="dropdown citation-dropdown">
        <button class="btn btn-outline-primary dropdown-toggle"
                type="button"
                (click)="toggleDropdown()">
          {{ selectedCitation?.title || 'Zitation auswählen' }}
        </button>
        <ul class="dropdown-menu"
            [class.show]="dropdownOpen">
          <li *ngFor="let item of citations">
            <button class="dropdown-item"
                    [class.active]="item === selectedCitation"
                    (click)="selectCitation(item)">
              {{ item.title }}
            </button>
          </li>
        </ul>
      </div>
      <div class="citation-result" *ngIf="selectedCitation">
        <div class="citation-text" [innerHTML]="selectedCitation.details"></div>
      </div>
    </div>

    <div class="metadata-export-container">
      <h2 class="simple-view-element-header">{{ 'item.page.metadataExport.header' | translate }}</h2>
      <div class="btn-group metadata-export-button-group">
        <button class="btn btn-outline-primary dropdown-toggle"
                type="button"
                (click)="toggleExportDropdown()">
          {{ selectedFormat?.label || 'Format wählen' }}
        </button>
        <ul class="dropdown-menu" [class.show]="exportDropdownOpen">
          <li *ngFor="let format of exportFormats">
            <button class="dropdown-item"
                    [class.active]="format === selectedFormat"
                    (click)="selectFormat(format)">
              {{ format.label }}
            </button>
          </li>
        </ul>
        <button class="btn btn-outline-primary"
                (click)="downloadFile(selectedFormat)">
          Download
        </button>
      </div>
    </div>
    <div>
      <a class="btn btn-outline-primary" role="button" [routerLink]="[itemPageRoute + '/full']" tabindex="0">
        <i class="fas fa-info-circle"></i> {{"item.page.link.full" | translate}}
      </a>
    </div>
  </div>
</div>
